import { render } from "./Marcia.vue?vue&type=template&id=e5a2ca92&scoped=true"
import script from "./Marcia.vue?vue&type=script&lang=js"
export * from "./Marcia.vue?vue&type=script&lang=js"

import "./Marcia.vue?vue&type=style&index=0&id=e5a2ca92&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5a2ca92"]])

export default __exports__